<div class="bn-alert-notice bn-info-notice" *ngIf="!hideAlert">
    <div class="bn-icon">
        <img src="./assets/img/images/bn-icon-info.svg" alt="info icon" />
    </div>
    <div class="bn-content">
        <div class="bn-content-text">
            <div class="bn-content-text-sub">
                <div class="bn-content-text-title">Information</div>
                <div class="bn-content-close">
                    <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer" alt="close icon"
                        (click)="onClose()" />
                </div>
            </div>
            <div class="bn-content-desc">Checking / Savings account payments not available for this policy.</div>
        </div>
    </div>
</div>